import { AsidePanelActionsButton } from '../../../..';
import * as React from 'react';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { CARD_SECTION_ASSIGNEES } from '../constants';
import { IAssigneesPanelButtonProps } from './types';
import { CLASS_CARD_DETAILS_SECTION, SECTION_CREATION_WAITING_TIME } from '../../../constants';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import {
    CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER
} from '../../../../asidePanel/components/AsidePanelActionsButton/constants';
import { getAsidePanelActionsButtonTooltip } from 'app/view/react_components/aside_panel/asidePanel/helpers/getAsidePanelActionsButtonTooltip';

export function AssigneesPanelButton({
    assignedToDetailsCount,
    tooltip,
    isShow,
    onClick
}: IAssigneesPanelButtonProps) {
    if (!isShow) return null;

    const className = CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER + '--assignees';
    const classNameSection = CLASS_CARD_DETAILS_SECTION + '--assignees';

    const { isCommentsColumn, showedProperties, openedProperty, addShowedProperty } = React.useContext(AsidePanelContext);
    const isShowed = showedProperties.has(EAsidePanelProperty.CARD_ASSIGNEES) && openedProperty !== EAsidePanelProperty.CARD_ASSIGNEES;
    const [isOpened, setIsOpened] = React.useState(null);
    const onOpened = () => setIsOpened(true);
    const onClosed = () => setIsOpened(false);

    return (
        <AsidePanelActionsButton
            className={className}
            indicatorNumber={assignedToDetailsCount}
            icon={'user'}
            isOpened={isOpened}
            openedProperty={EAsidePanelProperty.CARD_ASSIGNEES}
            sectionSelector={`.${classNameSection}`}
            title={CARD_SECTION_ASSIGNEES}
            tooltip={tooltip && getAsidePanelActionsButtonTooltip({ value: tooltip })}
            onClick={() => {
                onClick();
                if (!isShowed) {
                    addShowedProperty(EAsidePanelProperty.CARD_ASSIGNEES, isCommentsColumn);
                    setTimeout(() => {
                        const button = document.querySelector(`.${classNameSection} .settings-section__title-add`) as HTMLButtonElement;
                        if (button) {
                            button.focus();
                            button.click();
                        }
                    }, SECTION_CREATION_WAITING_TIME);
                }
            }}
            onOpen={onOpened}
        >
        </AsidePanelActionsButton>
    );
}
